// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__-5qwM","error":"Error_error__mVtVr","cursor":"Error_cursor__2rrit"};